// extracted by mini-css-extract-plugin
export default {"SelectionCursor":"pdf-editor_SelectionCursor__1iKyt"};